import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  map,
  Subscription,
  debounceTime,
  distinctUntilChanged,
  startWith,
} from 'rxjs';
import { EsriUtils } from 'app/shared/utils/esri.utils';

@Component({
  selector: 'app-scale-bar',
  templateUrl: 'scale-bar.component.html',
  styleUrls: ['scale-bar.component.scss'],
})
export class ScaleBarComponent implements OnChanges, OnDestroy {
  @ViewChild('inputEl', { static: true })
  inputElRef: ElementRef<HTMLInputElement>;

  @Input()
  mapView: __esri.MapView;

  @Input()
  value: number;
  @Output()
  valueChange = new EventEmitter<number>();

  private mapViewSubscription: Subscription;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.mapView) {
      this.handleMapView();
    }
  }

  ngOnDestroy() {
    this.mapViewSubscription?.unsubscribe();
  }

  onInputChange(e) {
    const value = this.inputElRef?.nativeElement?.valueAsNumber;
    if (value !== this.value) {
      this.value = value;

      if (this.mapView) {
        const viewpoint = this.mapView.viewpoint.clone();
        viewpoint.scale = value;
        this.mapView.goTo(viewpoint);
      }
    }
  }

  private handleMapView() {
    this.mapViewSubscription?.unsubscribe();
    if (!this.mapView) {
      return;
    }

    this.mapViewSubscription = EsriUtils.watch(this.mapView, 'scale')
      .pipe(
        map((e) => e.newValue.toFixed()),
        debounceTime(100),
        startWith(this.mapView.scale),
        distinctUntilChanged()
      )
      .subscribe((value) => {
        this.value = value;
      });
  }
}
